
export default [
  {
    name: `instruction_1`,
    title: `指をスライドさせて360°で探索します。`,
  },
];
